import axios from "axios";
import store from "@/store";
//
var request = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://blitzbit.io/api/public"
      : "http://localhost:3000/api/public",
  withCredentials: true
});

//
const errorResponse = error => {
  // const title = error.response.status === 400 ? 'Ошибка!' : 'Ошибка сервера!'
  const title =
    error.response.status === 400
      ? "Ошибка!"
      : "Сессия истекла - обновите страницу";
  const message = error.response.data.message;
  //
  store.dispatch("modals/openModal", { name: "info", title, message });
};
//
export function getValutes() {
  return request.get("/valutes").catch(errorResponse);
}

export function getValute(id) {
  return request.get("/valutes/" + id).catch(errorResponse);
}

export function getValuteCategories() {
  return request.get("/valute-categories").catch(errorResponse);
}

export function getTradePairs() {
  return request.get("/trade-pairs");
}

export function getValuteForms(id, type, step) {
  type = type || "give";
  step = step || 1;
  //
  return request
    .get(`/valutes/${id}/forms`, { params: { type, step } })
    .catch(errorResponse);
}
//
export function getReserve() {
  return request.get("/reserve").catch(errorResponse);
}
//
export function getReviews() {
  return request.get("/reviews").catch(errorResponse);
}

export function addReview(data) {
  return request.post("/reviews", data).catch(errorResponse);
}
//
export function userLogin({ login, password }) {
  return request.post("/auth/login", { login, password }).catch(errorResponse);
}
//restore handler
export function userRestore(email) {
  return request.post("/auth/restore", { email }).catch(errorResponse);
}

export function userRegister({ email, login, password, referal }) {
  return request
    .post("/auth/register", { email, login, password, referal })
    .catch(errorResponse);
}
//
export function getProfile(token) {
  return request.get("/profile", { headers: { token } }).catch(errorResponse);
}

export function editProfile(token, data) {
  return request({
    url: "/profile",
    method: "post",
    headers: { token },
    data
  }).catch(errorResponse);
}

export function postOutputRequest(token, data) {
  return request({
    url: "/profile/balance-output",
    method: "post",
    headers: { token },
    data
  }).catch(errorResponse);
}
//
export function addTransaction(token, data) {
  return request({
    url: "/transactions",
    method: "post",
    headers: { token },
    data
  }).catch(errorResponse);
}

export function getTransaction(id) {
  return request.get("/transactions/" + id).catch(errorResponse);
}

export function putTransaction(id, token, data) {
  return request({
    url: "/transactions/" + id,
    method: "post",
    headers: { token },
    data
  }).catch(errorResponse);
}
// info
export async function getInfo() {
  return request.get("/info").catch(errorResponse);
}
//
export function getVerifiedCardStatus(cardNumber) {
  return request.get(`/bankCards/${cardNumber}`);
}



// WEBPACK FOOTER //
// ./src/api/index.js